import { stringify } from 'utils/queryParam';

const GEOCODING_URL = 'https://api.mapbox.com/geocoding/v5/mapbox.places';

/**
 * Return ReverseGeocoding api url
 * @param {number} latitude
 * @param {number} longitude
 */
export const getReverseGeocodingURL = (longitude, latitude) => {
  const URL = `${GEOCODING_URL}/${longitude},${latitude}.json`;
  const params = {
    types: 'country,region,postcode,district,place,address',
    access_token: process.env.REACT_APP_MAPBOX_KEY,
  };
  return stringify(URL, params);
};

const formatGeographicContext = context => {
  let locationInfo = {};
  context.forEach(element => {
    switch (element.place_type[0]) {
      case 'region': {
        // get state code. 'us-ak' => 'AK'
        let regionName = element.text;
        if (element.properties.short_code) {
          regionName = element.properties.short_code.split('-')[1].toUpperCase();
        }
        locationInfo[element.place_type[0]] = regionName;
        break;
      }
      case 'address': {
        locationInfo['street_number'] = element['address'];
        locationInfo['address'] = element['text'];
        break;
      }
      case 'country': {
        locationInfo['country'] = element.text;
        locationInfo['countryCode'] = element.properties.short_code.toUpperCase();
        break;
      }
      default: {
        locationInfo[element.place_type[0]] = element.text;
      }
    }
  });

  return locationInfo;
};

export const formatGeographicFeature = geographicFeature => {
  if (geographicFeature) {
    return formatGeographicContext(geographicFeature.features);
  }
  return {};
};

export const getUserCurrentLocation = function (options) {
  return new Promise(function (resolve, reject) {
    navigator.geolocation.getCurrentPosition(resolve, reject, options);
  });
};

export const formatLocationInfo = locationData => {
  let locationInfo = '';
  if (locationData.street_number) {
    locationInfo += locationData.street_number + ' ';
  }
  if (locationData.address) {
    locationInfo += locationData.address + ', ';
  }

  if (locationData.place) {
    locationInfo += locationData.place + ', ';
  }

  if (locationData.region) {
    locationInfo += `${locationData.region} ${locationData.postcode || ''}, `;
  }
  if (locationData.country) {
    locationInfo += locationData.country;
  }
  return locationInfo;
};

export const isLatitude = lat => {
  return isFinite(lat) && Math.abs(lat) <= 90;
};

export const isLongitude = lng => {
  return isFinite(lng) && Math.abs(lng) <= 180;
};

/**
 * Return ReverseGeocoding api url
 * @param {number} latitude
 * @param {number} longitude
 */
export const getForwardGeocodingURL = (searchValue, countryCode) => {
  const URL = `${GEOCODING_URL}/${searchValue}.json`;
  const params = {
    limit: 5,
    types: 'region,postcode,district,place,address',
    access_token: process.env.REACT_APP_MAPBOX_KEY,
  };
  //If countryCode is not provided, remove country filter
  if (countryCode !== '') {
    params['country'] = countryCode;
  }
  return stringify(URL, params);
};

export const formatLocationSearchResponse = locationSearchResponse => {
  return locationSearchResponse.map(element => {
    return {
      longitude: element.center[0],
      latitude: element.center[1],
      placeName: element.place_name,
      context: element.context,
    };
  });
};
